(function() {
  $.nette.ext('datagrid-spinners', {
    before: function(xhr, settings) {
      let el;

      if (settings.nette) {
        el = settings.nette.el;

        if (
          el.is('.ajax')
          || el.is('.datagrid-per-page-submit')
          || el.is('#datagridgroup_action_submit')
          || el.is('.datagrid-filter-submit-button')
        ) {
          $.addDatagridSpinner(el.parent().closest('.datagrid'));
        }
      }
    },
    complete: function() {
      $.removeDatagridSpinner();
    }
  });
}).call(this);
